/*
 * Copyright (c) 2020. American Express Company
 */

import React from 'react';

import { IconLeft } from '@americanexpress/dls-react';
import { BackButtonViewModel } from 'src/types/view-models/back-button.view.model';
import NavigationService from '../../services/navigation.service';

import IconButton from 'src/components/icon-button/IconButton';
import { DLSSize } from 'src/types/dls-size.enum';
import { ButtonType } from 'src/types/button-type.enum';
import Selectors from 'src/utils/selectors';

export default function BackButton(props: BackButtonViewModel): JSX.Element {
    const history = props.drawerProps?.history || props.history;
    const variant = props.onDarkBackground ? ButtonType.PRIMARY_DARK : ButtonType.SECONDARY;
    return (
        <div className={props.className}>
            <IconButton
                variant={variant}
                data-cy={Selectors.General.BACK_BTN}
                onClick={async () => {
                    if (props.beforeBack) {
                        await props.beforeBack();
                    }
                    props.handleBack ? props.handleBack() : NavigationService.goBack(history).catch(console.error);
                }}
                title="Back"
                size={props.size}
                icon={<IconLeft size={props.size || DLSSize.SMALL} />}
            />
        </div>
    );
}
